import styles from "./CardContent.module.scss";

function CardContent({ title, description }) {
  return (
    <div className={styles.base}>
      {title && <div className={styles.title}>{title}</div>}
      <div className={styles.description}>
        {description ||
          "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Tempora recusandae inventore vitae, excepturi nemo praesentium, consectetur nulla atque repudiandae impedit!"}
      </div>
    </div>
  );
}

export default CardContent;
